import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const NAV = [
  { label: "Home", href: "/" },
  { label: "The InSight Approach", href: "/#approach" },
  { label: "Areas We Help", href: "/#areas" },
  { label: "About", href: "/#about" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "The InSight Journal", href: "/#journal" },
  { label: "Start Your Health Profile", href: "/health-profile" },
];

export const Footer = () => (
  <footer className="bg-forestdeep text-ivory" id="contact" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Logo dark />
          <p className="mt-6 font-serif text-2xl text-ivory/90">Dr Rohan Dikshit</p>
          <p className="mt-2 text-sm text-ivory/60 tracking-wide">MBBS, DMRD · FMF UK Certified</p>
          <p className="mt-6 text-sm text-ivory/70 leading-relaxed max-w-sm">
            Virtual consultations for patients across India. To begin, complete your InSight
            Health Profile and our team will contact you regarding the next step.
          </p>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-goldlight mb-6">Navigate</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.label}>
                <Link to={n.href} className="text-sm text-ivory/75 hover:text-goldlight transition-colors duration-300">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-goldlight mb-6">Legal</p>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li><Link to="/privacy" className="hover:text-goldlight transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-goldlight transition-colors" data-testid="footer-terms">Terms of Use</Link></li>
            <li><Link to="/disclaimer" className="hover:text-goldlight transition-colors" data-testid="footer-medical-disclaimer-link">Medical Disclaimer</Link></li>
            <li><Link to="/admin" className="text-ivory/45 hover:text-goldlight transition-colors" data-testid="footer-admin-link">Practice Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-ivory/15 space-y-4" data-testid="footer-disclaimer">
        <p className="text-xs text-ivory/55 leading-relaxed max-w-4xl">
          Medical Disclaimer: InSight Metabolics is a medical practice. Content on this website is for general
          information and education only and does not constitute medical advice, diagnosis or treatment. A
          doctor–patient relationship is established only through direct consultation. In a medical emergency,
          contact your local emergency services immediately.
        </p>
        <p className="text-xs text-ivory/55 leading-relaxed max-w-4xl">
          Virtual medical care is subject to applicable laws, licensing requirements and prescribing regulations
          in the patient&rsquo;s location. Availability of consultation, diagnosis, prescriptions and investigations
          may vary by country.
        </p>
        <p className="text-xs text-ivory/45 pt-2">© 2026 InSight Metabolics. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
